export function average(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return 0;
        let sum = 0, count = 0;
        for (const v of arr) {
        const n = Number(v);
        if (Number.isFinite(n)) {
            sum += n;
            count++;
        }
        }
        return count > 0 ? sum / count : 0;
    }